import { View } from "@react-pdf/renderer";
import ContractStyles from "../assets/styles/contractStyles";
import ContractListItem from "../constants/listItem";
import RenderClauses from "../constants/renderClauses";
import { formatSerialNumber, numberClauseTree } from "../constants/serialNumbers";

const obligations = [
  {
    title: "Firms",
    content: "Where the Appointed Representative is a Firm:",
    clauses: [
      {
        content:
          "The Company shall approve the appointment of any director, partner or Appointed Representative (such approval shall not be unreasonably withheld) provided that such director, partner or Appointed Representative agrees to be bound by the terms and conditions of this Contract.",
      },
      {
        content:
          "The Company reserves power to make any payments due to the Appointed Representative to any one director, partner or, as applicable, Appointed Representative in full discharge of its obligations.",
      },
      {
        content:
          "The Company may accept the instruction of any partner or director or, in the case of an LLP, any Appointed Representative as the instruction of the Firm and any contract signed by any such person and expressed to have been signed on behalf of the relevant Firm as representing the agreement of that Firm.",
      },
      {
        content:
          "The Company reserves the right to require evidence of agreement of all directors, shareholders, partners or Appointed Representatives before undertaking any transaction.",
      },
    ],
  },
  {
    title: "Plans",
    content: "The Company reserves the right to:",
    clauses: [
      {
        content:
          "decline to process any application for plans from an AppointedRepresentative; and",
      },
      {
        content: "vary the range and specification of the plans.",
      },
    ],
  },
  {
    title: "The Company’s Activities",
    content:
      "The Company reserves the right to expand the activities of the business into other enterpriseareas of whatsoever nature or provide any service within the limitations of the Memorandum and Articles of the Company.",
  },
  {
    title: "Exclusion of liability for IT Software failure",
    content:
      "The Company shall have no liability for any failure or malfunction of the IT software for any reason (including negligence on the part of the Company, its servants or agents) and the Company shall not be liable for any losses or damage suffered by the Appointed Representative as a result of such failure or malfunction including any claims for loss of profit or other financial loss.",
  },
  {
    title: "Force Majeure",
    content:
      "Neither party shall be liable to the other to the extent that it is not reasonably able to perform this contract as a result of any cause beyond the reasonable control of the party who would otherwise be in breach of this contract.",
  },
  {
    title: " Provisions for Regulatory Changes",
    content:
      "This contract shall include a provision for adapting to changes in regulatory requirements, ensuring that both parties can promptly adjust to any new FCA rules or guidance to maintain compliance.",
  },
  {
    title: "Severance",
    content:
      "If at any time any provision of this Contract is or becomes invalid or unenforceable in anyrespect that shall not affect the validity or enforceability of any other provision of this Contract.",
  },
  {
    title: "Entire Contract",
    content: "",
    clauses: [
      {
        content:
          "This Contract constitutes the entire agreement between the Parties and supersedes all prior agreements in connection with the subject matter.",
      },
      {
        content:
          "No director, employee or agent of the Company is authorised to make any representation or warranty not contained in this Contract and the Appointed Representative acknowledges that they have not relied on any such oral or written representations or warranties.",
      },
    ],
  },
  {
    title: "Addresses",
    content:
      "Each of the Parties shall give notice in writing to the other of any change or acquisition of any postal or electronic mail address or telephone or facsimile number as soon as practicable and in any event within 48 hours of such change or acquisition.",
  },
  {
    title: "Notices",
    content:
      "Notices may be given by either Party by being sent to the other Party’s address as mentioned in clause 9.8. by hand, post or fax or by electronic mail to the address. Any notice posted shall be deemed to have been received by the addressee 48 hours after posting or any facsimile or email shall be deemed to have been received at 9.00am on the Business Day following the day that it was transmitted to the correct facsimile or email address.",
  },
  {
    title: "Joint and Several",
    content:
      "All agreements on the part of either of the Parties which comprise more than one person or entity shall be joint and several.",
  },
  {
    title: "No partnership and extent of agency",
    content:
      "Nothing in this Contract shall create a partnership or joint venture between the Parties. The Appointed Representative shall be an agent of the Company but only to the extent provided for in this Contract and shall not act so as to commit or bind the Company to any further extent.",
  },
  {
    title: "The Company’s right to assign",
    content:
      "The Company may assign all its rights and obligations under this Contract whereupon this Contract shall continue as if originally made with such assignee and the Appointed Representative shall continue to be bound accordingly.",
  },
  {
    title: "Waiver",
    content:
      "No delay or omission by the Company in exercising any right of power or remedy provided by law or under this Contract shall affect that right of power or remedy or operate as a waiver of it.",
  },
  {
    title: "The Contracts (Rights of Third Parties) Act 1999",
    content:
      "No person who is not a Party to this Contract may enforce any of its provisions under the Contracts (Rights of Third Parties) Act 1999.",
  },
  {
    title: "Amendment of this Contract and other contractual documents",
    content: "",
    clauses: [
      {
        content:
          "The Company reserves the right to amend this Contract by giving no less than 28 days notice in writing to the Appointed Representative at any time.",
      },
      {
        content:
          "Subject to clauses 9.15.3. and 9.15.4., any amendment to this Contract shall take effect following the Company giving to the Appointed Representative 1 month’s notice in writing.",
      },
      {
        content:
          "Where any amendment is necessary to comply with any applicable law or regulation, it shall take effect immediately upon deemed receipt of notice as set out in clause 9.9.",
      },
      {
        content:
          "Amendments to any agreed Commission & Fees, the Compliance Manual and the Sales Process may be made by the Company giving such notice as it reasonably deems necessary and shall take effect immediately from the date specified in the notice.",
      },
    ],
  },
  {
    title: "Taxation",
    content: "",
    clauses: [
      {
        content:
          "All amounts payable by and to the Appointed Representative are inclusive of VAT, where applicable, unless otherwise stated.",
      },
      {
        content:
          "The Appointed Representative warrants and represents to the Company that they are an independent contractor and, as such, bears sole responsibility for the payment of tax and national insurance contributions which may be found due from it in relations to any payments or arrangements made under this Contract and, further, agrees to indemnify the Company in respect of all and any income tax which may be found due from the Company on any payments or arrangements made under this Contract together with any interest, penalties or gross-up thereon.",
      },
    ],
  },
  {
    title: "Proper law and jurisdiction",
    content:
      "This Contract shall be governed by and construed in accordance with English law and the Parties submit to the non-exclusive jurisdiction of the English Courts.",
  },
  {
    title: "Counterparts",
    content:
      "This Contract may be entered into in any number of counterparts each of which when executed and delivered shall be an original, but all the counterparts together shall constitute one and the same instrument.",
  },
];

const Miscellaneous = ({ serialNumber = 9 }) => {
  const styles = ContractStyles();

  return (
    <View style={[styles.flexColumn, styles.gap_sm]} break>
      <ContractListItem
        id="miscellaneous"
        marker={formatSerialNumber(serialNumber)}
        styles={styles}
        textStyle={[styles.contentSemibold, styles.text_primary]}
      >
        Miscellaneous
      </ContractListItem>

      <View style={[styles.flexColumn, styles.gap_sm]}>
        {numberClauseTree(obligations, serialNumber).map(({ number, title, content, clauses }) => (
          <View
            key={number}
            style={[
              styles.flexColumn,
              styles.gap_xs,
              // { paddingTop: number === "4.5." ? styles.py_lg : styles.py_md },
            ]}
          >
            <ContractListItem
              marker={number}
              markerWidth={24}
              styles={styles}
              textStyle={styles.buttonTextSmall}
            >
              {title}
            </ContractListItem>
            {content && (
              <ContractListItem
                marker=""
                markerWidth={0}
                styles={styles}
                textStyle={styles.buttonTextSmall}
              >
                {content}
              </ContractListItem>
            )}

            <RenderClauses clauses={clauses} styles={styles} number={number} />
          </View>
        ))}
      </View>
    </View>
  );
};

export default Miscellaneous;
